import { CartValidationErrorKey } from '@libs/common-next/utils';

import type { DeliveryType } from '../../../../../core/src';
import type { CartValidationErrorDetails, ItemsListItem } from '../../../types';

export const parseStockErrors = (
    errors: CartValidationErrorDetails[],
    itemsList: ItemsListItem[],
    attemptedFulfillmentMethod?: DeliveryType
) => {
    const stockErrorCodes: string[] = [CartValidationErrorKey.OUT_OF_STOCK, CartValidationErrorKey.INSUFFICIENT_STOCK];

    const relevantErrors = errors?.filter(({ errorCode }) => stockErrorCodes.includes(errorCode));

    const formattedErrors = relevantErrors.map(error => {
        const itemInCart = itemsList.find(({ id: itemId }) => itemId === error.lineItemId);

        const item = itemInCart
            ? {
                  ...error,
                  fulfillmentMethod: attemptedFulfillmentMethod ?? itemInCart.fulfillmentMethod,
                  isAttemptedFMTransition: Boolean(attemptedFulfillmentMethod),
              }
            : null;

        return item;
    });

    const stockErrors = formattedErrors.filter(Boolean) || [];

    return stockErrors;
};
